import React, { useState, useEffect } from 'react';
import './Introduction.css';

const PrivateNewsletterExport = () => {
    useEffect(() => {
        // Initialisation Firebase si non déjà fait
        if (typeof window !== 'undefined' && window.firebase && !window.firebaseDb) {
            try {
                if (!window.firebaseApp) {
                    const firebaseConfig = {
                        apiKey: "AIzaSyC1yaePZ_CkNCev7kD747d72nIc4_tDWVM",
                        authDomain: "newschool-form.firebaseapp.com",
                        databaseURL: "https://newschool-form-default-rtdb.europe-west1.firebasedatabase.app",
                        projectId: "newschool-form",
                        storageBucket: "newschool-form.firebasestorage.app",
                        messagingSenderId: "340466982381",
                        appId: "1:340466982381:web:024b941dcd51dfb0bf5be4",
                        measurementId: "G-ZVYY0KSKGC"
                    };
                    window.firebaseApp = window.firebase.initializeApp(firebaseConfig);
                }
                window.firebaseDb = window.firebase.database();
            } catch (error) {
                console.error('Erreur Firebase:', error);
            }
        }
    }, []);
    const [exportStatus, setExportStatus] = useState('');
    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [subscriberEmails, setSubscriberEmails] = useState([]);
    const [isLoadingEmails, setIsLoadingEmails] = useState(false);

    const handlePasswordSubmit = () => {
        const requiredPassword = process.env.REACT_APP_NEWSLETTER_EXPORT_PASSWORD;
        console.log('Password entered:', password);
        console.log('Required password:', requiredPassword);
        console.log('Match:', password === requiredPassword);
        
        if (password === requiredPassword) {
            setIsAuthenticated(true);
            setExportStatus('✅ Accès autorisé');
            loadSubscriberEmails(); // Charger les emails dès l'accès validé
        } else {
            setExportStatus(`❌ Mot de passe incorrect (attendu: "${requiredPassword || 'non défini'}")`);
            setPassword('');
        }
    };

    const loadSubscriberEmails = async () => {
        if (!window.firebaseDb) {
            setExportStatus('Service Firebase indisponible.');
            return;
        }
        
        setIsLoadingEmails(true);
        try {
            const snapshot = await window.firebaseDb
                .ref('contacts')
                .orderByChild('newsletter')
                .equalTo(true)
                .once('value');

            const emailsSet = new Set();
            snapshot.forEach(child => {
                const v = child.val();
                if (v && v.email) {
                    const e = String(v.email).trim().toLowerCase();
                    if (e) emailsSet.add(e);
                }
            });

            const emails = Array.from(emailsSet);
            setSubscriberEmails(emails);
            setExportStatus(`✅ ${emails.length} email(s) abonné(s) trouvé(s)`);
        } catch (err) {
            console.error('Erreur chargement emails:', err);
            setExportStatus('Erreur lors du chargement des emails.');
        } finally {
            setIsLoadingEmails(false);
        }
    };

    const handleOpenEmailClient = () => {
        if (!subscriberEmails.length) {
            setExportStatus('Aucun email abonné trouvé.');
            return;
        }

        // Créer le lien mailto avec tous les emails dans le champ "À" (To)
        const toEmails = subscriberEmails.join(',');
        const subject = encodeURIComponent('Newsletter NewSchool');
        const body = encodeURIComponent('Bonjour,\n\n[Votre message ici]\n\nCordialement,\nL\'équipe NewSchool');
        
        // Construire l'URL mailto avec les emails dans le champ "to"
        const mailtoUrl = `mailto:${encodeURIComponent(toEmails)}?subject=${subject}&body=${body}`;
        
        // Ouvrir l'application de mail par défaut
        window.location.href = mailtoUrl;
        
        setExportStatus(`✅ Application de mail ouverte avec ${subscriberEmails.length} destinataires dans le champ "À"`);
    };


    return (
        <div className="container" style={{ maxWidth: 500, margin: '60px auto', padding: '32px', background: '#fff', borderRadius: 12, boxShadow: '0 6px 24px rgba(0,0,0,0.08)' }}>
            <h2 style={{ textAlign: 'center', marginBottom: 24 }}>Export Newsletter Privé</h2>
            
            {!isAuthenticated ? (
                // Section d'authentification
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                        🔒 Accès sécurisé requis
                    </div>
                    <input
                        type="password"
                        placeholder="Mot de passe"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        onKeyPress={e => e.key === 'Enter' && handlePasswordSubmit()}
                        style={{ padding: '8px', borderRadius: '5px', border: '1.5px solid #e0e0e0', fontSize: '1rem', width: '220px' }}
                    />
                    <button
                        type="button"
                        className="submit-btn"
                        onClick={handlePasswordSubmit}
                        style={{ width: '100%' }}
                    >
                        🔓 Valider l'accès
                    </button>
                    {exportStatus && (
                        <div className={`status-message ${exportStatus.includes('✅') ? 'success' : 'error'}`} style={{ width: '100%', textAlign: 'center' }}>
                            {exportStatus}
                        </div>
                    )}
                </div>
            ) : (
                // Section d'export (visible uniquement après authentification)
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                    <div style={{ fontSize: '14px', color: '#28a745', marginBottom: '8px' }}>
                        ✅ Accès autorisé - Newsletter Export
                    </div>
                    
                    {isLoadingEmails ? (
                        <div style={{ textAlign: 'center' }}>
                            <span className="spinner"></span>
                            Chargement des emails...
                        </div>
                    ) : (
                        <>
                            {/* Affichage de la liste des emails */}
                            {subscriberEmails.length > 0 && (
                                <div style={{ 
                                    maxHeight: '200px', 
                                    overflowY: 'auto', 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '5px', 
                                    padding: '10px',
                                    width: '100%',
                                    fontSize: '12px',
                                    backgroundColor: '#f8f9fa'
                                }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                                        📧 Emails abonnés ({subscriberEmails.length}):
                                    </div>
                                    {subscriberEmails.map((email, index) => (
                                        <div key={index} style={{ marginBottom: '2px' }}>
                                            • {email}
                                        </div>
                                    ))}
                                </div>
                            )}
                            
                            {/* Bouton d'ouverture du client mail */}
                            <button
                                type="button"
                                className="submit-btn"
                                onClick={handleOpenEmailClient}
                                disabled={subscriberEmails.length === 0}
                                style={{ 
                                    width: '100%',
                                    backgroundColor: subscriberEmails.length > 0 ? '#007bff' : '#6c757d'
                                }}
                            >
                                📧 Ouvrir dans mon application mail ({subscriberEmails.length} destinataires)
                            </button>
                        </>
                    )}
                    
                    {exportStatus && !exportStatus.includes('Accès autorisé') && (
                        <div className={`status-message ${exportStatus.includes('✅') ? 'success' : 'error'}`} style={{ width: '100%', textAlign: 'center' }}>
                            {exportStatus}
                        </div>
                    )}
                    
                    <button
                        type="button"
                        onClick={() => setIsAuthenticated(false)}
                        style={{ 
                            background: 'transparent', 
                            border: 'none', 
                            color: '#666', 
                            fontSize: '12px', 
                            cursor: 'pointer',
                            marginTop: '8px' 
                        }}
                    >
                        🔒 Verrouiller l'accès
                    </button>
                </div>
            )}
        </div>
    );
};

export default PrivateNewsletterExport;
